import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-484ef852"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg" }
const _hoisted_2 = {
  key: 0,
  class: "AppFullLoding"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lds-ripple" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " 잠시만 기다려주세요. ", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "logo_wrap"
}
const _hoisted_7 = { class: "header" }
const _hoisted_8 = { class: "logo" }
const _hoisted_9 = { class: "login" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "modal-card" }
const _hoisted_13 = { class: "modal-card-head" }
const _hoisted_14 = { class: "modal-card-title" }
const _hoisted_15 = {
  class: "modal-card-body",
  style: {"font-size":"1.2rem"}
}
const _hoisted_16 = { class: "modal-card-foot" }
const _hoisted_17 = {
  class: "notification_wrap",
  style: {"position":"fixed","top":"0","z-index":"999"}
}
const _hoisted_18 = { class: "text has-text-centered" }
const _hoisted_19 = { class: "modal-content scrollBar" }
const _hoisted_20 = { class: "image" }
const _hoisted_21 = ["src"]
const _hoisted_22 = {
  key: 2,
  class: "AppFooter footer mt-3 p-5"
}
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"has-text-left\" data-v-484ef852><div class=\"f-logo\" data-v-484ef852> KCK Doc Center </div><div data-v-484ef852><a href=\"/v/Privacy\" target=\"_blank\" data-v-484ef852>개인정보 취급방침</a> | <a href=\"/site_map/site_map.xml\" target=\"_blank\" data-v-484ef852>Site Map</a></div><div class=\"mt-6\" data-v-484ef852> ⓒ KCK Corp. All Rights Reserved. </div></div>", 1)
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.main_loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    ((!_ctx.isFullSize))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createTextVNode("KCK Doc Center")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              (!_ctx.isLogin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_router_link, {
                      to: "/login",
                      class: "Nfs-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("로그인")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isLogin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                    }, "로그아웃")
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    _createElementVNode("div", {
      onKeypress: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.keyPressEnterOpenPop && _ctx.keyPressEnterOpenPop(...args)), ["enter"])),
      class: _normalizeClass(["modal", { 'is-active': _ctx.alert_basic.is_open }])
    }, [
      _createElementVNode("div", {
        class: "modal-background",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
      }),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("header", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.alert_basic.title), 1),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
            class: "delete",
            "aria-label": "close"
          })
        ]),
        _createElementVNode("section", _hoisted_15, _toDisplayString(_ctx.alert_basic.msg), 1),
        _createElementVNode("footer", _hoisted_16, [
          _createElementVNode("button", {
            ref: "close_btn",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
            class: "button is-success right"
          }, "닫기", 512)
        ])
      ])
    ], 34),
    _createElementVNode("div", _hoisted_17, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notification_list, (d, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "notification is-info",
          key: idx
        }, [
          _createElementVNode("div", _hoisted_18, _toDisplayString(d.msg), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["modal", { 'is-active': _ctx.img_popup.is_open }])
    }, [
      _createElementVNode("div", {
        class: "modal-background",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeImgPopup && _ctx.closeImgPopup(...args)))
      }),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("p", _hoisted_20, [
          _createElementVNode("img", {
            src: _ctx.img_popup.img_url,
            alt: ""
          }, null, 8, _hoisted_21)
        ])
      ]),
      _createElementVNode("button", {
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeImgPopup && _ctx.closeImgPopup(...args))),
        class: "modal-close is-large",
        "aria-label": "close"
      })
    ], 2),
    ((!_ctx.isFullSize))
      ? (_openBlock(), _createElementBlock("footer", _hoisted_22, _hoisted_24))
      : _createCommentVNode("", true)
  ]))
}